import BlNavBarLargeMv from './BlNavBarLargeMv.vue'

BlNavBarLargeMv.install = function(Vue) {
  Vue.component(BlNavBarLargeMv.name, BlNavBarLargeMv)
}

export default BlNavBarLargeMv
